module.exports = __webpack_public_path__ + "images/ffa8bfbddcddf469ab7068e43575f03b-bg.jpg";